import { FF_REFERRAL_PROGRAM } from '@wetransfer/transfer/constant/experiments';
import scriptLoader from '@wetransfer/transfer/helper/script-loader';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

import trackCustomer from './events/trackCustomer';

const friendBotSrc = 'https://static.fbot.me/friendbuy.js';
const campaignSrc = 'https://campaign.fbot.me/';

const windowAPIKey = 'friendbuyAPI';

const init = async (merchantId: string): Promise<void> => {
  if (getVariant(FF_REFERRAL_PROGRAM) !== 'on') {
    return;
  }

  let friendbuyAPI = window[windowAPIKey];

  if (!friendbuyAPI) {
    window[windowAPIKey] = [];
    friendbuyAPI = window[windowAPIKey];
  }
  // registers your merchant using your merchant ID found in the
  // retailer app https://retailer.friendbuy.io/settings/general
  friendbuyAPI.merchantId = merchantId;
  friendbuyAPI.push(['merchant', friendbuyAPI.merchantId]);
  await scriptLoader(friendBotSrc);
  await scriptLoader(`${campaignSrc}${merchantId}/campaigns.js`);
};

export const eventsFactory = {
  trackCustomer,
};

export const getFriendBuyAPI: () => ArrayFriendBuy<any> = () =>
  window[windowAPIKey] || [];

export default init;
